import { RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { SERVER_HOST, SERVER_PORT } from "../lib/api";
import { useI18n } from "../lib/i18n";

const Cell = ({ label, value, testid, accent }) => (
  <div className="p-6 border-[#30363D]">
    <p className="text-xs uppercase tracking-[0.2em] text-[#6E7681]">{label}</p>
    <p data-testid={testid} className={`mt-3 font-mono text-xl sm:text-2xl font-semibold ${accent || "text-[#F0F6FC]"}`}>{value}</p>
  </div>
);

export const StatusPanel = ({ status, stats, loading, refresh }) => {
  const { t } = useI18n();
  const online = status?.online;
  const label = t(status == null ? "CHECKING" : online ? "ONLINE" : "OFFLINE");
  const color = status == null ? "text-[#D29922]" : online ? "text-[#3FB950]" : "text-[#F85149]";
  return (
    <section id="status" className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="font-mono text-xs text-[#38BDF8]">{t("stEyebrow")}</p>
          <h2 data-testid="status-title" className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">{t("stTitle")}</h2>
        </div>
        <Button variant="outline" onClick={refresh} disabled={loading} data-testid="status-refresh-btn"
          className="rounded-full border-[#30363D] bg-transparent hover:bg-[#21262D]">
          <RefreshCw className={`mr-2 h-4 w-4 ${loading ? "animate-spin" : ""}`} /> {t("stPing")}
        </Button>
      </div>
      <div data-testid="server-status-card"
        className="rounded-2xl border border-[#30363D] bg-[#161B22]/70 backdrop-blur-xl grid grid-cols-2 lg:grid-cols-5 divide-x divide-y lg:divide-y-0 divide-[#30363D] overflow-hidden">
        <div className="p-6 col-span-2 lg:col-span-1 flex items-center gap-4">
          <span className={`h-4 w-4 rounded-full ${online ? "bg-[#3FB950] pulse-ring" : online === false ? "bg-[#F85149]" : "bg-[#D29922] animate-pulse"}`} />
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#6E7681]">{t("stStatus")}</p>
            <p data-testid="server-status-label" className={`mt-1 font-mono text-2xl font-extrabold ${color}`}>{label}</p>
          </div>
        </div>
        <Cell label={t("stHost")} value={SERVER_HOST} testid="server-host" accent="text-[#38BDF8]" />
        <Cell label={t("stPort")} value={SERVER_PORT} testid="server-port" accent="text-[#38BDF8]" />
        <Cell label={t("stLatency")} value={online ? `${status.latency_ms} ${t("ms")}` : "—"} testid="server-latency" />
        <Cell label={t("stUins")} value={stats?.registered_via_site ?? "—"} testid="stats-registered" />
      </div>
      <p data-testid="server-flap-info" className="mt-4 font-mono text-xs text-[#6E7681]">
        {t(status?.flap_hello ? "flapOk" : online ? "flapWait" : "flapNone")}
      </p>
    </section>
  );
};
